import withShouldRender from "modules/Core/higher-order-components/withShouldRender";
import Container from "../Container";

export default withShouldRender(Container)